import { isEmpty } from "@utils";

export const getWordDefinition = async (axios, config, word) => {
	return await axios
		.get(`${config.API_SERVICE}/v1/definitions/${word}`)
		.then((response) => {
			const { data } = response.data;
			const definition = data[0].pos[0];
			const partOfSentence = definition.part;
			const defaultSense = definition.senses[0].txt;
			const sense = !isEmpty(defaultSense)
				? defaultSense
				: definition.senses[0].subsenses[0].txt;

			return { sense, partOfSentence };
		});
};
